import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=02a5c534&scoped=true"
import script from "./Headline.vue?vue&type=script&lang=js"
export * from "./Headline.vue?vue&type=script&lang=js"
import style0 from "./Headline.vue?vue&type=style&index=0&id=02a5c534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a5c534",
  null
  
)

export default component.exports